import { createContext, useContext, useEffect, useState } from 'react';
import { AuthenticatedUser, UserContext } from 'src/app/user/context';

interface EmbeddedDemoContext {
  enableEmbeddedDemo: boolean;
}

const EmbeddedDemoContext = createContext<EmbeddedDemoContext | null>(null);

export const EmbeddedDemoProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const user = useContext(UserContext);
  // Initialize state from localStorage or defaults
  const [enableEmbeddedDemo, setEnableEmbeddedDemo] = useState<boolean>(
    (user as AuthenticatedUser)?.enableEmbedded,
  );

  // Save to localStorage whenever state changes
  useEffect(() => {
    if ((user as AuthenticatedUser)?.enableEmbedded !== enableEmbeddedDemo) {
      setEnableEmbeddedDemo((user as AuthenticatedUser)?.enableEmbedded);
    }
  }, [user, enableEmbeddedDemo]);

  const value = {
    enableEmbeddedDemo,
  };

  return (
    <EmbeddedDemoContext.Provider value={value}>
      {children}
    </EmbeddedDemoContext.Provider>
  );
};

export const useEmbeddedDemo = () => {
  const context = useContext(EmbeddedDemoContext);
  if (!context) {
    throw new Error(
      'useEmbeddedDemo must be used within a EmbeddedDemoProvider',
    );
  }
  return context;
};

export { EmbeddedDemoContext };
